// blockchain/Web3Singleton.ts
import Web3 from "web3";
import { getWeb3 } from "@/libs/web3";

let instance: Web3 | null = null;

export default class Web3Singleton {
  /**
   * Get a Web3 instance (Singleton pattern)
   * @returns Web3 instance
   */
  static getInstance(): Web3 {
    if (!instance) {
      try {
        instance = getWeb3();  // Get new Web3 instance with Magic provider
      } catch (error) {
        console.error("Error initializing Web3:", error);
        throw error;
      }
    }
    return instance;
  }

  /**
   * Reset the Web3 instance
   */
  static resetInstance(): void {
    instance = null;
  }
}
